module.exports = __webpack_public_path__ + "static/media/alice.198037ed.webp";